module.exports = __webpack_public_path__ + "img/if_12.64984466.png";